import React from "react";
import PropTypes from "prop-types";
import { browserPropType } from "components/propTypes";
import RtrImage from "../shared/rtr-image";

const mobileImageUrl = "https://cdn.rtrcdn.com/sites/default/files/imgs/Calendar_Icon_mWeb.png";
const desktopImageUrl = "https://cdn.rtrcdn.com/sites/default/files/imgs/Calendar_Icon_Desktop.png";

class GridTopFiltersEvent extends React.Component {
  static propTypes = {
    browser: browserPropType,
    onClickCancel: PropTypes.func.isRequired,
    onClickContinue: PropTypes.func.isRequired,
  };

  getEventPanel() {
    // TODO: use svg instead
    const imageSrc = this.props.browser.isMobileViewport ? mobileImageUrl : desktopImageUrl;
    return <RtrImage src={imageSrc} />;
  }

  render() {
    return (
      <div className="grid-top-filters-event">
        <div className="grid-top-filters__content">{this.getEventPanel()}</div>
        <div className="grid-top-filters__buttons">
          <button className="btn-secondary" onClick={this.props.onClickCancel}>
            Just Browsing
          </button>
          <button className="btn" onClick={this.props.onClickContinue}>
            Enter Dates
          </button>
        </div>
      </div>
    );
  }
}

export default GridTopFiltersEvent;
